import typo from '../flightBriefTypography.module.css';
import styles from './StatItem.module.css';

/**
 * Compact "icon + label + value" cell used in the BasicInfos and Onboard rows
 * (e.g. AIRCRAFT / REGISTRATION / SEATS / CATERING ...).
 *
 * The icon is a composition slot so callers plug in any SVG component, instead
 * of selecting one through an icon-name string.
 * @param {object} props
 * @param {React.ReactNode} [props.icon] - Leading icon slot.
 * @param {React.ReactNode} props.label - Upper-case caption above the value.
 * @param {React.ReactNode} props.children - The value to display.
 * @param {'center' | 'start'} [props.align] - Horizontal alignment of the cell.
 * @param {boolean} [props.multiline] - Allow value text to wrap (onboard cells).
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function StatItem({
  icon = null,
  label,
  children,
  align = 'center',
  multiline = false,
  className = '',
}) {
  return (
    <div className={`${styles.stat} ${styles[`align-${align}`]} ${multiline ? styles.multiline : ''} ${className}`}>
      <div className={styles['icon-and-label']}>
        {icon ? <span className={styles.icon}>{icon}</span> : null}
        <span className={`${styles.label} ${typo['p2-light']} ${typo['neutral-500']}`}>{label}</span>
      </div>
      <span className={`${styles.value} ${typo['p1-light']}`}>{children}</span>
    </div>
  );
}

export default StatItem;
